// extracted by mini-css-extract-plugin
module.exports = {"header":"NodeSettings_header_2kHlY","warningIcon":"NodeSettings_warningIcon_2zu4N","descriptionContainer":"NodeSettings_descriptionContainer_1XqLS"};